export default {
  ADD_MESSAGE: 'ADD_MESSAGE',
  EDIT_MESSAGE: 'EDIT_MESSAGE',
  REMOVE_MESSAGE: 'REMOVE_MESSAGE',
  ADD_CHAT: 'ADD_CHAT',
  ADD_MESSAGES: 'ADD_MESSAGES',
  CHANGE_ACTIVE_CHAT: 'CHANGE_ACTIVE_CHAT',
  SET_NEW_MESSAGE: 'SET_NEW_MESSAGE',
  CLEAR_NEW_MESSAGE: 'CLEAR_NEW_MESSAGE',
  CLEAR_MESSENGER: 'CLEAR_MESSENGER',
  CLEAR_CHAT: 'CLEAR_CHAT',
  CHANGE_CHAT_ATTR: 'CHANGE_CHAT_ATTR',
  SET_CHANNELS_SORTED: 'SET_CHANNELS_SORTED',
  CHANGE_USER_ONLINE_STATUS: 'CHANGE_USER_ONLINE_STATUS',
};



// WEBPACK FOOTER //
// ./src/reducers/messages/types.js